import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './Components/Header';
import Sidebar from './Components/SideBar';
import './App.css';

import Home from './Pages/Home'; 
import CustomerList from './Pages/CustomerList';
import AddCustomer from './Pages/AddCustomer'; 
import ImportCustomer from './Pages/ImportCustomer'; 
import ImportTask from './Pages/ImportTask'; 
import EditCustomer from './Pages/EditCustomer';
import DepartmentList from './Pages/DepartmentList';
import TaskThemeList from './Pages/TaskThemeList';
import TaskTitleList from './Pages/TaskTitleList';
import Designationlist from './Pages/Designationlist';
import WorkingHours from './Pages/WorkingHours';
import StaffAttendance from './Pages/StaffAttendance';
import PermissionLeaveList from './Pages/PermissionLeaveList';
import Task from './Pages/Task';
import OdList from './Pages/ODlist';
import Salary from './Pages/Salary';
import SalaryAided from './Pages/SalaryAided';
import SalaryDetail from './Pages/SalaryDetail';
import SalaryAidedDetail from './Pages/SalaryAidedDetail';
import Settings from './Pages/Settings';
import LeavePermissionForm from './Pages/LeavePermissionForm';
import AddTask from './Pages/AddTask';
import AddOD from './Pages/AddOD';
import AddStaffSalary from './Pages/AddStaffSalary';
import AddAidedStaffSalary from './Pages/AddAidedStaffSalary';
import AddStaffAttendance from './Pages/AddStaffAttendance';
import EditStaffAttendance from './Pages/EditStaffAttendance';
import EditTask from './Pages/EditTask';
import EditLeavePermissionForm from './Pages/EditLeavePermissionForm';
// import EditOD from './Pages/EditOD';
import EditSalarySF from './Pages/EditSalarySF';
import EditAidedStaffSalary from './Pages/EditAidedStaffSalary';
import ViewSalaryAided from './Pages/ViewSalaryAided';
import ViewSalarySF from './Pages/ViewSalarySF';
import ViewOD from './Pages/ViewOD';
import ViewTask from './Pages/ViewTask';
import SubTaskList from './Pages/SubTaskList';
import CommentList from './Pages/CommentList';
import ViewLeave from './Pages/ViewLeave';
import ViewStaffAttendance from './Pages/ViewStaffAttendance';
import Privileges from './Pages/Privileges';
import Login from './Pages/Login';
import ViewCustomer from './Pages/ViewCustomer';
import AddPrivilegeUser from './Pages/AddPrivilegeUser';
import EditPrivilegeUser from './Pages/EditPrivilegeUser';
import SalaryTableExcel from './Pages/SalaryTableExcel'; 
import SalaryAidedTableExcel from './Pages/SalaryAidedTableExcel'; 

const MOBILE_BREAKPOINT = 768;

const App = () => {
  // desktop collapsed/open state (controlled by App)
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // mobile overlay open/close state (controlled by App)
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // track whether we are currently on a narrow screen
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  const location = useLocation();

  // on mount and resize, keep App control of default states
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileView(mobile);

      if (mobile) {
        // on mobile keep sidebar closed by default and close any desktop-open state
        setIsSidebarOpen(false);
      } else {
        // on desktop open by default and ensure mobile overlay closed
        setIsSidebarOpen(true);
        setIsMobileOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // toggle called from Header or Sidebar toggle button
  const toggleSidebar = () => {
    if (isMobileView) {
      setIsMobileOpen(prev => !prev);
    } else {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const closeMobileSidebar = () => setIsMobileOpen(false);

  const isLoginPage = location.pathname === '/login';
  if (isLoginPage) return <Login />;

    return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobileView={isMobileView}
        closeMobileSidebar={closeMobileSidebar}
      />

      <main
        className={`main-content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'} ${isMobileOpen ? 'mobile-overlay' : ''}`}
      >
        {/* Single wrapper so every page gets the same outer-container styles */}
        <div className="outer-container">
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/departmentList" element={<DepartmentList />} />
            <Route path="/taskThemeList" element={<TaskThemeList />} />
            <Route path="/taskTitleList" element={<TaskTitleList />} />
            <Route path="/userlist" element={<CustomerList />} />
            <Route path="/Designationlist" element={<Designationlist />} />
            <Route path="/workinghours" element={<WorkingHours />} />
            <Route path="/staffattendance" element={<StaffAttendance />} />
            <Route path="/permissionleavelist" element={<PermissionLeaveList />} />
            <Route path="/task" element={<Task />} />
            <Route path="/privileges/:emp_id" element={<Privileges />} />
            <Route path="/odlist" element={<OdList />} />
            <Route path="/salary" element={<Salary />} />
            <Route path="/salaryaided" element={<SalaryAided />} />
            <Route path="/salary/:user_id" element={<SalaryDetail />} />
            <Route path="/salary-aided/:user_id" element={<SalaryAidedDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/addcustomer" element={<AddCustomer />} />
            <Route path="/importcustomer" element={<ImportCustomer />} />
            <Route path="/importtask" element={<ImportTask />} />
            <Route path="/addattendance" element={<AddStaffAttendance />} />
            <Route path="/addleave" element={<LeavePermissionForm />} />
            <Route path="/addtask" element={<AddTask />} />
            <Route path="/addod" element={<AddOD />} />
            <Route path="/addsalary/:user_id" element={<AddStaffSalary />} />
            <Route path="/addsalaryaided/:user_id" element={<AddAidedStaffSalary />} />
            <Route path="/addprivilegeuser" element={<AddPrivilegeUser />} />
            <Route path='/editcustomer/:user_id' element={<EditCustomer />} />
            <Route path='/editattendance/:id' element={<EditStaffAttendance />} />
            <Route path='/edittask/:task_id' element={<EditTask />} />
            <Route path='/editleave/:leave_id' element={<EditLeavePermissionForm />} />
            {/* <Route path='/editod/:id' element={<EditOD />} /> */}
            <Route path='/editsalary/:salary_id' element={<EditSalarySF />} />
            <Route path='/editsalaryaided/:salary_id' element={<EditAidedStaffSalary />} />
            <Route path='/editprivilegeuser/:id' element={<EditPrivilegeUser />} />
            <Route path="/viewcustomer/:user_id" element={<ViewCustomer />} />
            <Route path="/viewattendance/:id" element={<ViewStaffAttendance />} />
            <Route path="/viewleave/:leave_id" element={<ViewLeave />} />
            <Route path="/viewtask/:task_id" element={<ViewTask />} />
            <Route path="/subtasklist/:task_id" element={<SubTaskList />} />
            <Route path="/commentlist/:task_id" element={<CommentList />} />
            <Route path="/viewod/:od_id" element={<ViewOD />} />
            <Route path="/viewsalary/:salary_id" element={<ViewSalarySF />} />
            <Route path="/viewsalaryaided/:salary_id" element={<ViewSalaryAided />} />
            <Route path="/salarytableexcel" element={<SalaryTableExcel />} />
            <Route path="/salaryaidedtableexcel" element={<SalaryAidedTableExcel />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default App;
